module.exports = __webpack_public_path__ + "media/images/IMG_0016-20-cd2af12c28f157d2ddd99cf2f0a55918.jpg";